module.exports = __webpack_public_path__ + "img/resume.284f66fe.png";